import { FC } from 'react';
import { useController } from 'react-hook-form';
import FieldContainer from '@common/FieldContainer';

import { PATTERN } from '@utils/validators/pattern';
import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

const maxLength = 2048;

interface StudentIdProps {
  name: string;
}

const StudentId: FC<StudentIdProps> = ({ name }) => {
  const { field, fieldState } = useController({
    name,
    defaultValue: '',
    rules: {
      validate: (value) => {
        if (!value) return '학번을 입력해 주세요.';
        if (!PATTERN.STUDENT_ID_PATTERN.test(value)) return '학번은 영문자, 숫자, -, _만 사용할 수 있습니다.';
        return true;
      },
    },
  });

  return (
    <FieldContainer name="학번" required={true}>
      <div className={cx('inputArea')}>
        <input
          {...field}
          type="text"
          className={cx('input', { error: fieldState.invalid })}
          placeholder="학번을 입력해 주세요."
          maxLength={maxLength}
        />
        {fieldState.invalid && (
          <div className={cx('noticeTextArea')}>
            <span className={cx('noticeText', 'error')}>{fieldState.error?.message}</span>
          </div>
        )}
      </div>
    </FieldContainer>
  );
};

export default StudentId;
